import { assertNever } from "../../lib/assertNever";
import {
  emptyTimelineFilters,
  type TimelineFilters,
} from "../../lib/timelineFilters";
export type Model = { announcement: string; filters: TimelineFilters };
export type Msg =
  | { kind: "Announce"; text: string }
  | { kind: "Filters"; filters: TimelineFilters };
export const initialModel: Model = {
  announcement: "",
  filters: emptyTimelineFilters,
};
export function update(model: Model, msg: Msg): [Model, never[]] {
  switch (msg.kind) {
    case "Announce":
      return [{ ...model, announcement: msg.text }, []];
    case "Filters":
      return [{ ...model, filters: msg.filters }, []];
    default:
      return assertNever(msg);
  }
}
